"use strict";
require.context("../images", true);
import "src/decidim/homepage_proposals/main";
import "src/decidim/form_filter.js";
